<template>
  <div id="app">
    <t-header />
    <t-modal />
    <t-modal-register />
    <router-view/>
    <!-- <t-footer /> -->
  </div>
</template>

<script>
export default {
  components: {
    THeader: () => import('@/components/layout/header')
    // TFooter: () => import('@/components/layout/footer')
  },
  watch: {
    '$route' (to, from) {
      document.title = 'Mala direta Trackmob'
    }
  },
  beforeMount () {
    if (!this.$store.getters.isLoggedIn) {
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/css/colors.scss";

#app,
body {
  font-family: 'Sarabun', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  padding: 0;
}

.tui.ui.button {
  background: $white-100;
  border: 1px solid $border-color;
  border-radius: 3px;
  padding: 8px 16px;
  font-size: 16px;
  line-height: 22px;
  font-weight: 700;
  color: $gray-700;
  cursor: pointer;
  box-shadow: none;

  &.icon {
    padding: 8px 14px;
  }

  &:hover {
    background: $blue-700 !important;
    border-color: $blue-700;
    box-shadow: none !important;
    color: $white-100 !important;
  }

  &:disabled {
    background: $gray-100;
    border-color: $border-color;
    color: $gray-500;
    opacity: 1 !important;
  }

  &.link {
    color: $gray-500;
    border: none;
  }
}

.tui.ui.basic.primary.button,
.tui.ui.basic.primary.buttons .button {
  border-color: $blue-500 !important;
  color: $blue-500 !important;
  box-shadow: none !important;
  font-weight: 700;

  &:hover {
    background: $blue-700 !important;
    border-color: $blue-700;
    box-shadow: none !important;
    color: $white-100 !important;
  }

  &:focus {
    background: $blue-900 !important;
    border-color: $blue-900;
    box-shadow: none !important;
    color: $white-100 !important;
  }
}

.tui.ui.primary.button,
.tui.ui.primary.buttons .button {
  background: $blue-500;
  border-color: $blue-500;
  color: $white-100;
  text-shadow: none;
  background-image: none;
  box-shadow: none;

  .tui-icon {
    margin-left: 10px;
  }

  &:hover {
    background: $blue-700 !important;
    border-color: $blue-700;
    box-shadow: none !important;
  }

  &:focus {
    background: $blue-900 !important;
    border-color: $blue-900;
    box-shadow: none !important;
  }

  &.small {
    font-size: 12.8px;
    line-height: 16px;
    padding: 7px 16px;
  }

  &:disabled {
    background: $gray-100;
    border-color: $border-color;
    color: $gray-500;
    opacity: 1 !important;
  }

  &.button-uppercase {
    font-size: 12.8px;
    line-height: 18px;
    text-transform: uppercase;
  }
}

a { color: $blue-500 }

.tui.ui.form {
  .form-field,
  .tui.form-field {
    margin-bottom: 20px;
    position: relative;

    &:last-child {
      margin-bottom: 0;
    }

    &.disabled {
      label {
        margin-bottom: 0;
        font-weight: 700;
      }
    }

    .field > label,
    label {
      font-size: 12.8px;
      line-height: 18px;
      display: block;
      margin-bottom: 10px;
      color: $gray-700;
      font-weight: 400;

      .required {
        color: $red-500;
      }
    }

    &.wide.field .ui.input input {
      width: 0;
    }

    &.aligned {
      display: flex;

      &.right { justify-content: flex-end; }
      &.center { justify-content: center; }
    }

    input:not([type="file"]) {
      background: $white-100;
      border: 1px solid $border-color;
      border-radius: 3px;
      width: 100%;;
      padding: 8px 15px;
      font-size: 16px;
      line-height: 22px;

      &:focus {
        outline: none;
        box-shadow: none;
        border-color: $blue-500;
      }

      &:disabled {
        pointer-events: none;
        opacity: 1;
        padding: 0;
        border: none;
        color: $gray-600;
        font-size: 16px;
      }

      &::placeholder {
        color: $gray-500
      }
    }

    input[type="file"] {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      text-align: center;
      opacity: 0;
      cursor: pointer;

      &:hover + .fake-input-file {
        background: $blue-700 !important;
        border-color: $blue-700;
        box-shadow: none !important;
        color: $white-100 !important;
      }

      &:focus + .fake-input-file {
        background: $blue-900 !important;
        border-color: $blue-900;
        box-shadow: none !important;
        color: $white-100 !important;
      }
    }

    input[type="checkbox"] {
      width: auto;
    }

    .fake-input-file {
      padding: 13px 16px;
      width: 100%;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      border-radius: 3px;
      background: $white-100;
      border: 1px solid $blue-500;
      color: $blue-500;
      position: relative;
      cursor: pointer;

      &:hover {
        background: $blue-700 !important;
        border-color: $blue-700;
        box-shadow: none !important;
        color: $white-100 !important;
      }

      &:focus {
        background: $blue-900 !important;
        border-color: $blue-900;
        box-shadow: none !important;
        color: $white-100 !important;
      }

      .icon {
        margin-left: 10px;
      }
    }

    &.error {
      input:not([type="file"]) {
        border-color: $red-500;
      }

      .field-error {
        color: $red-500;
      }
    }

    .ui.selection.dropdown {
      min-height: 40px;
      color: $gray-700;
      border: 1px solid $border-color;
      border-radius: 3px;
      font-size: 16px;

      .text {
        font-size: 16px;
        color: $gray-700;

        &.default {
          color: $gray-500;
        }
      }
    }

    .icon-input {
      position: absolute;
      bottom: 12px;
      right: 15px;
      font-size: 16px;
      color: $gray-600;
    }

    .count-input {
      font-size: 12.8px;
      line-height: 18px;
      color: $gray-500;
      position: absolute;
      right: 15px;
      bottom: 10px;
    }
  }
}

// Titles
.title-three {
  font-weight: 800;
  font-size: 25px;
  line-height: 36px;
}

// Cards
.wrap-card-group {
  border: 1px solid $border-color;
  border-radius: 3px;
  margin-bottom: 20px;

  .wrap-card {
    border-radius: 0;
  }

  .wrap-info-card {
    padding: 0 30px 20px;

    .text {
      margin-bottom: 0;
      margin-top: 20px;
    }

    .text-info {
      font-size: 16px;
      line-height: 23px;
      margin-bottom: 0;
      color: $gray-500;
    }
  }
}

.wrap-card {
  border-radius: 3px;
  border: 1px solid $border-color;
  padding: 20px 30px;
  margin-bottom: 30px;

  .text {
    font-size: 12.8px;
  }

  &[data-type-card="success"] {
    background-color: $green-500;
    border-color: $green-500;
    color: $white-100;

    .title-three {
      margin-bottom: 0;
    }
  }

  &[data-type-card="error"] {
    background-color: $red-500;
    border-color: $red-500;
    color: $white-100;

    .title-three {
      margin-bottom: 0;
    }
  }

  &[data-type-card="info"] {
    background-color: $gray-500;
    border-color: $gray-500;
    color: $white-100;

    .title-three {
      margin-bottom: 0;
    }
  }
}

// Tootip
.wrap-tootip {
  position: absolute;
  top: 0;
  right: 0;

  .tooltip-content {
    font-size: 16px;
    color: $gray-500;
    cursor: pointer;
  }

  [data-tooltip] {
    position: relative;

    &::after {
      white-space: normal;
      font-size: 12.8px;
      background: $blue-100;
      border: 1px solid $blue-500;
      line-height: 18px;
      width: 200px;
      padding: 10px 20px;
      color: $blue-500;
      border-radius: 3px;
      box-shadow: none;
    }
  }
  [data-position="right center"][data-tooltip]:before {
    background: $blue-100;
    box-shadow: -1px 1px 0 0 $blue-500;
  }
}
</style>
